import OfflineEnhancedLayout from './OfflineEnhancedLayout';

export default OfflineEnhancedLayout;
